import React, { useState } from "react";
import { Field, reduxForm, change } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import Wysiwyg from "../../../Components/Forms/wysiwyg";
import NDTRCTags from "../../../Components/Forms/ndtrctags";
import FooterForm from "../../../Components/Lib/FooterForm";
import Autosuggest from "../../../Components/Forms/autocomplete";
import switcbutton from "../../../Components/Forms/switch";
import { renderTextField, renderField, renderselectsimple } from "../../../Components/Forms/renders";

// Verzamel de locaties waar deze gebruiker evenementen aan mag koppelen: de
// union van de locaties van al zijn actieve partner-organisaties.
const locatiesUitOrganisaties = (user) => {
  const perId = new Map();
  (user?.userOrganisaties || []).forEach((org) => {
    if (!org || org.actief === false) return;
    (org.locaties || []).forEach((loc) => {
      const id = loc?._id || loc;
      if (!id) return;
      perId.set(id.toString(), loc?.what?.title?.value || id.toString());
    });
  });
  return Array.from(perId, ([id, value]) => ({ id, value }));
};

const LogboekFormWebsite = ({ handleSubmit, dispatch, user }) => {
  const [isaevent, setisaevent] = useState(false);
  const [legacyLocation, setLegacyLocation] = useState(null);
  const isLocatiebeheerder = user?.role === "locatiebeheerder";

  const orgLocations = React.useMemo(() => locatiesUitOrganisaties(user), [user]);

  const checkevent = (value) => {
    if (value.target.value === "EVENEMENT") {
      setisaevent(true);
    } else {
      setisaevent(false);
    }
  };

  const onChangeInput = (e) => {
    const newSlug = e.target.value
      .toLowerCase()
      .replace(/[^\w\s-]+/g, "")
      .replace(/\s+/g, "-");
    dispatch(change("vvvitem_insert", "what.slug.value", newSlug));
  };

  // Legacy-accounts zitten nog op restricedLocation in plaats van op een
  // partner-organisatie; haal de naam van die ene locatie apart op.
  React.useEffect(() => {
    if (!isLocatiebeheerder || orgLocations.length > 0 || !user?.restricedLocation) return;
    let cancelled = false;
    const id = user.restricedLocation;
    setLegacyLocation({ id, value: "" });
    fetch("/api/item", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        setLegacyLocation({ id, value: data?.items?.[0]?.what?.title?.value || "" });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isLocatiebeheerder, orgLocations.length, user?.restricedLocation]);

  const locations = orgLocations.length > 0 ? orgLocations : legacyLocation ? [legacyLocation] : [];

  React.useEffect(() => {
    if (!isLocatiebeheerder) return;
    dispatch(change("vvvitem_insert", "metadata.entitytype", "EVENEMENT"));
    setisaevent(true);
  }, [isLocatiebeheerder, dispatch]);

  // Bij precies één locatie kiezen we die zelf; bij meerdere kiest de gebruiker.
  const enigeLocatieId = locations.length === 1 ? locations[0].id : null;
  const enigeLocatieNaam = locations.length === 1 ? locations[0].value : null;
  React.useEffect(() => {
    if (!isLocatiebeheerder || !enigeLocatieId) return;
    dispatch(change("vvvitem_insert", "subitemsgroupId", enigeLocatieId));
    dispatch(change("vvvitem_insert", "subitemsgroup", { id: enigeLocatieId, value: enigeLocatieNaam }));
  }, [isLocatiebeheerder, enigeLocatieId, enigeLocatieNaam, dispatch]);

  const onSelectLocation = (e) => {
    const id = e.target.value;
    const gekozen = locations.find((l) => l.id === id);
    dispatch(change("vvvitem_insert", "subitemsgroup", gekozen ? { id: gekozen.id, value: gekozen.value } : null));
  };

  const locatieOpties = locations.reduce((acc, l) => ({ ...acc, [l.id]: l.value }), {});

  return (
    <form onSubmit={handleSubmit}>
      <div className="col-sm-12">
        <h4 className="info-text">Vul hier de algemene gegevens in</h4>
      </div>
      {isLocatiebeheerder ? (
        <>
          <div className="form-group">
            <label className="form-label">Type item</label>
            <div className="form-control" style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}>
              Evenement
            </div>
            <small className="text-muted">U kunt alleen evenementen aanmaken</small>
          </div>
          <Field
            name="metadata.entitytype"
            component="input"
            type="hidden"
            validate={required({ msg: "Type item is verplicht" })}
          />
        </>
      ) : (
        <Field
          className="form"
          name="metadata.entitytype"
          validate={required({ msg: "Type item is verplicht" })}
          label="Maak eerste een keuze"
          component={renderselectsimple}
          options={{
            EVENEMENT: "Evenement",
            LOCATIE: "Locatie",
          }}
          onChange={(value) => checkevent(value)}
        />
      )}
      {isaevent && (
        <React.Fragment>
          {!isLocatiebeheerder && (
            <Field name="subitemsgroup" component={Autosuggest} label="Kies om het item aan een locatie te koppelen" />
          )}
          {isLocatiebeheerder && locations.length === 1 && (
            <div className="form-group">
              <label className="form-label">Locatie</label>
              <div className="form-control" style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}>
                {locations[0].value || "Uw vaste locatie"}
              </div>
            </div>
          )}
          {isLocatiebeheerder && locations.length > 1 && (
            <Field
              name="subitemsgroupId"
              validate={required({ msg: "Locatie is verplicht" })}
              label="Kies een locatie voor dit evenement"
              component={renderselectsimple}
              options={locatieOpties}
              onChange={onSelectLocation}
            />
          )}
          <Field name="subitemsgroup" component="input" type="hidden" />
          <Field name="event.everyyear" type="input" component={switcbutton} label="Wordt dit evenement jaarlijks herhaald?" />
        </React.Fragment>
      )}
      <Field name="what.title.value" onChange={onChangeInput} validate={required({ msg: "Titel is verplicht" })} type="text" component={renderField} label="Titel" />
      <Field name="what.shortdescription.value" validate={required({ msg: "Beschrijving is verplicht" })} type="textarea" component={renderTextField} label="Korte Omschrijving" />
      <Field name="what.longdescription.value" type="textarea" component={Wysiwyg} label="Lange Omschrijving" className="form-control" normalize={(value) => value.toString("html")} />
      <Field name="types" validate={required({ msg: "Types zijn verplicht" })} type="text" component={NDTRCTags} label="Tags" className="form-control" />

      <FooterForm />
    </form>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "vvvitem_insert", // a unique identifier for this form
})(LogboekFormWebsite);

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
